import { call, put, takeLatest } from "redux-saga/effects";
import {
  onResetPassword,
  onResetPasswordSuccess,
  onResetPasswordError,
} from "../Store/Slices/resetPasswordSlice";
import { callResetPasswordApi } from "../Context/loginUser";

function* resetPasswordSagaWorker({ payload }) {
  try {
    const response = yield call(callResetPasswordApi, {
      token: payload?.token,
      newPassword: payload?.newPassword,
    });
    const code = response?.httpStatusCode ?? response?.status ?? response?.status_code;
    const ok = code === 200 || code === "200";

    if (ok) {
      yield put(
        onResetPasswordSuccess({
          message: response?.message ?? "Password reset successful",
          status_code: code ?? 200,
        })
      );
      return;
    }

    yield put(
      onResetPasswordError({
        message: response?.message ?? "Failed to reset password",
        status_code: code ?? 400,
      })
    );
  } catch (error) {
    const message =
      error?.response?.data?.message ?? error?.message ?? "Something went wrong";
    yield put(onResetPasswordError({ message, status_code: 400 }));
  }
}

export default function* resetPasswordSaga() {
  yield takeLatest(onResetPassword.type, resetPasswordSagaWorker);
}
